module.exports = __webpack_public_path__ + "img/V2.65554f33.jpg";